// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"a17c4e68","129":"0f3f2090","175":"d343eac4","416":"0327f700","439":"0b7aa81d","453":"c67a2750","823":"21f32078","884":"4f7c0349"}[chunkId] + ".chunk.js";
};